module.exports = __webpack_public_path__ + "img/redo.0ac3f269.svg";